<template>
	<div id="app">
		<div class="m-content-display">
			<Header v-if="notLogin && notfLogin"></Header>
			<div id="nav">
				<el-skeleton class="skelet" v-show="skeletonShow">
					<template slot="template">
						<el-skeleton-item variant="caption" class="app-skeleton-img" />
						<div style="width: 70%; margin: 10px auto; padding: 14px">
							<el-skeleton-item variant="p" style="width: 50%" class="app-skeleton-black" />
							<div style="display: flex; align-items: center; justify-items: space-between">
								<el-skeleton-item
									variant="text"
									style="margin-right: 16px"
									class="app-skeleton-black"
								/>
								<el-skeleton-item variant="text" style="width: 30%" class="app-skeleton-black" />
							</div>
						</div>
						<div class="skeleton-img-list">
							<el-skeleton-item
								variant="caption"
								style="width: 300px; height: 500px"
								class="app-skeleton-black"
							/>
							<el-skeleton-item
								variant="caption"
								style="width: 300px; height: 500px"
								class="app-skeleton-black"
							/>
							<el-skeleton-item
								variant="caption"
								style="width: 300px; height: 500px"
								class="app-skeleton-black"
							/>
						</div>
					</template>
				</el-skeleton>
				<router-view v-show="!skeletonShow" />
			</div>
			<Footer v-if="notLogin && notfLogin"></Footer>
		</div>
	</div>
</template>
<script>
	// @ is an alias to /src
	import Footer from '@/components/Footer.vue';
	import Header from '@/components/Header.vue';
	import { $systemAccessPlatform } from '@/api';
	var pc_h5__route = [
		{
			pc: '/',
			h5: '/',
		},
		{
			pc: '/',
			h5: '/home',
		},
		{
			pc: 'login',
			h5: '/login',
		},
		{
			pc: 'Forgot_password',
			h5: '/forget_password',
		},
		{
			pc: '/about',
			h5: '',
		},
		{
			pc: 'personal_center',
			h5: '/my',
		},
		{
			pc: 'ordermanage',
			h5: '/ordermessage',
		},
		{
			pc: 'orderdetails',
			h5: '/order_details',
		},
		{
			pc: '',
			h5: '/case_sharing',
		},
		{
			pc: '',
			h5: '/design_material',
		},
		{
			pc: '',
			h5: '/invoicing',
		},
		{
			pc: '',
			h5: '/invoicing_apply',
		},
		{
			pc: '',
			h5: '/invoicing_order',
		},
		{
			pc: '',
			h5: '/invoicing_details',
		},
		{
			pc: '',
			h5: '/daily_detail',
		},
		{
			pc: '',
			h5: '/cancel_order',
		},
		{
			pc: '',
			h5: '/news_details',
		},
		{
			pc: '',
			h5: '/order_operation',
		},
		{
			pc: 'personalinfo',
			h5: '/personal_data',
		},
		{
			pc: 'changepassword',
			h5: '/update_password',
		},
		{
			pc: 'defaultinvoice',
			h5: '/invoiceInfo',
		},
		{
			pc: 'mycourses',
			h5: '',
		},
		{
			pc: 'notification',
			h5: '/news',
		},
		{
			pc: 'clouddesignsolution',
			h5: '',
		},
		{
			pc: 'dailymanage',
			h5: '/daily_manage',
		},
		{
			pc: 'dailycreate',
			h5: '/create_daily',
		},
		{
			pc: 'financialmanage',
			h5: '/financial_management',
		},
		{
			pc: 'technical_services',
			h5: '/technical_services',
		},
		{
			pc: 'smart_lighting',
			h5: '/',
		},
		{
			pc: 'product_detail',
			h5: '/product_details',
		},
		{
			pc: 'smart_product',
			h5: '/smart_lighting',
		},
		{
			pc: 'case_details',
			h5: '/case_details',
		},
		{
			pc: 'training_services',
			h5: '',
		},
		{
			pc: 'coursed_details',
			h5: '',
		},
		{
			pc: 'aboutUs',
			h5: '',
		},
		{
			pc: 'aboutIntroduce',
			h5: '',
		},
		{
			pc: 'sign_up',
			h5: '',
		},
		{
			pc: 'searchResults',
			h5: '',
		},
		{
			pc: 'cloudDesign',
			h5: '',
		},
		{
			pc: 'helpDetails',
			h5: '',
		},
		{
			pc: 'helpDetails',
			h5: '',
		},
		{
			pc: '',
			h5: '/agreement',
		},
	];

	export default {
		name: 'Home',
		data() {
			return {
				skeletonShow: true,
				// 顶部导航背景图片配置
				background: {
					// 背景图片地址
					backgroundImage: 'url(' + require('./image/banner.png') + ')',
					// 背景图片是否重复
					backgroundRepeat: 'no-repeat',
					// 背景图片大小
					backgroundSize: 'cover',
					// 背景颜色
					backgroundColor: '#000',
					// 背景图片位置
					backgroundPosition: 'center top',
				},
			};
		},
		beforeCreate() {},
		created() {
			let post_name = GetQueryString('post_name');
			if (window.location.search && post_name) {
				this.$router.replace(decodeURIComponent(post_name));
				setTimeout(() => {
					this.hideSk();
				}, 700);
				return;
			}
			let is_mobile = isMobile();
			if (is_mobile) {
				check_h5();
				setTimeout(() => {
					this.hideSk();
				}, 700);
			}
		},
		mounted() {
			// 平台 访问量
			$systemAccessPlatform({}).then((res) => {});
			let checkIE = this.checkIe();
			if (checkIE != -1) {
				alert('请使用主流浏览器如谷歌浏览器');
			}

			setTimeout(() => {
				this.hideSk();
			}, 700);

			// document.body.oncopy = function () {
			//   return false;
			// }; //阻止复制\
			// document.onkeydown = function (e) {
			//   var ev = e || event;

			//   if (ev.ctrlKey == 1 && ev.keyCode == 67) {
			//     return false;
			//   }
			// };

			//取消选中并且取消右键操作
			document.oncontextmenu = function () {
				return false; //取消浏览器默认操作
			};

			// 获取友情链接
			this.$store.dispatch('getBlogroll');
		},
		components: {
			Footer,
			Header,
		},
		computed: {
			// 计算是否是登录页面
			notLogin() {
				return this.$route.path !== '/login';
			},
			// 计算是否是登录页面
			notfLogin() {
				return this.$route.path !== '/Forgot_password';
			},
		},
		methods: {
			hideSk() {
				this.$data.skeletonShow = false;
				this.$forceUpdate();
			},

			checkIe() {
				// if (document.documentMode) return document.documentMode;
				let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
				let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; //判断是否IE<11浏览器
				let isEdge = userAgent.indexOf('Edge') > -1 && !isIE; //判断是否IE的Edge浏览器
				let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
				if (isIE) {
					let reIE = new RegExp('MSIE (\\d+\\.\\d+);');
					reIE.test(userAgent);
					let fIEVersion = parseFloat(RegExp['$1']);
					if (fIEVersion == 7) {
						return 7;
					} else if (fIEVersion == 8) {
						return 8;
					} else if (fIEVersion == 9) {
						return 9;
					} else if (fIEVersion == 10) {
						return 10;
					} else {
						return 6; //IE版本<=7
					}
				} else if (isEdge) {
					return 'edge'; //edge
				} else if (isIE11) {
					return 11; //IE11
				} else {
					return -1; //不是ie浏览器
				}
			},
		},
	};
	function isMobile() {
		let mobile = navigator.userAgent.match(
			/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
		);
		return mobile != null;
	}

	// h5
	function check_h5() {
		let route = document.location.pathname;

		// 协议 域名 端口

		let urlParmas = `${document.location.protocol}//${document.domain}${
			document.location.port ? ':' + document.location.port : ''
		}`;

		// 路由
		let len = pc_h5__route.length;
		var param;
		//首页
		if (route == '/') {
			urlParmas += '/_mo_' + document.location.search;
			window.location.replace(urlParmas);
			return;
		}

		// h5 router usit
		if (route.indexOf('/_mo_') != -1) {
			param = `${route.replace('/_mo_', '')}${document.location.search}`;
			urlParmas += `/_mo_?post_name=${encodeURIComponent(param)}`;
			window.location.replace(urlParmas);
			return;
		}

		// pc router usit
		if (route.indexOf('/_dp_') != -1) {
			for (var i = 0; i < len; i++) {
				// 页面路径
				if (route.indexOf(pc_h5__route[i].pc) != -1 && pc_h5__route[i].pc.length > 2) {
					// h5存在此页面路径
					if (pc_h5__route[i].h5) {
						param = `${pc_h5__route[i].h5}${document.location.search}`;

						// 跳转
						urlParmas += `/_mo_?post_name=${encodeURIComponent(param)}`;
						window.location.replace(urlParmas);
					} else {
						// h5 不存在 跳pc
						// urlParmas += `${route}${document.location.search}`;
						// window.location.replace(urlParmas);
						urlParmas += '/_mo_';
						window.location.replace(urlParmas);
					}
					break;
					// 用 h5链接访问 h5
				}
			}

			return;
		}

		if (!(route.match(/_mo_/i) == '_mo_') && !(route.match(/_dp_/i) == '_dp_')) {
			urlParmas += '/_mo_';
			window.location.replace(window.location.origin);
			return;
		}
	}

	function GetQueryString(name) {
		var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	}
</script>

<style lang="scss">
	#app {
		font-family: Microsoft YaHei, PingFang SC, Avenir, Helvetica, Arial, sans-serif !important;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		// text-align: center;
		color: #2c3e50;
		width: 100%;
		min-width: 1100px;
		box-sizing: border-box;
		background-color: RGBA(16, 15, 15, 1);
		min-height: 100vh;
		overflow-y: hidden;
	}
	.m-content-display {
		margin: 0px auto;
		max-width: 1920px;
		min-width: 1100px;
		display: flex;
		flex-direction: column;
		min-height: 100%;
	}
	#nav {
		// width: 100%;
		// padding: 30px;
		flex: 1;

		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}
	.hoverbtn-_:hover {
		cursor: pointer;
		opacity: 0.6;
	}
	//修改全局 下拉框选中样式
	.el-select-dropdown__list {
		.el-select-dropdown__item {
			padding: 0 10px !important;
		}
		.selected {
			background: rgba(230, 50, 65, 0.1);
			font-size: 14px;
			font-family: PingFangSC-Regular;
			color: #e60000;
		}
	}

	.el-message {
		margin-top: 50px;
		padding: 10px 15px !important;

		.el-message__content {
			letter-spacing: 2px;
			line-height: 18px;
		}
	}

	::v-deep .el-tabs__item:focus.is-active.is-focus:not(:active) {
		-webkit-box-shadow: none;
		box-shadow: none;
	}
	.el-tabs__item:hover,
	.el-tabs__item.is-active {
		color: #e60000;
	}
	.el-tabs__active-bar {
		background-color: #e60000 !important;
	}
	img {
		-webkit-user-drag: none;
		-webkit-user-select: none;
		-moz-user-drag: none;
		-moz-user-select: none;
		-o-user-drag: none;
		-o-user-select: none;
	}
	.el-date-table td.current:not(.disabled) span {
		background-color: #e60000;
		color: #fff !important;
	}
	.el-button--text,
	.el-date-table td.today span {
		color: #e60000 !important;
	}
	.el-picker-panel__footer {
		.el-button.is-plain:focus,
		.el-button.is-plain:hover {
			border-color: #e60000;
			color: #e60000;
		}
	}

	// 日期
	.el-date-table td.end-date span,
	.el-date-table td.start-date span {
		background-color: $theme-color;
		color: #fff !important;
	}
	.el-date-table td.available:hover {
		color: $theme-color !important;
	}
	.max-zindex {
		z-index: 9999999999 !important;
	}
	.el-message {
		min-height: 44px !important;
		background: #1b1b1b;
		border-color: #1b1b1b;
		color: #fff !important;
		.el-message__icon {
			font-size: 16px;
		}
		.el-message__content {
			color: #fff !important;
		}
	}
	.el-time-panel__btn.confirm {
		color: #e60000 !important;
	}
	td.disabled {
		// background: #e6324110;
		div {
			background: #e6324110 !important;
			span {
				// background: #e6324110;
			}
		}
	}
	.color-red {
		// 弹窗按钮
		background: #e60000 !important;
		border: none;
		&:hover {
			background: #e60000 !important;
			opacity: 0.9;
		}
	}
	.cance-btn {
		background: transparent !important;
		&:hover {
			color: #606266;
		}
	}
	.app-skeleton-black {
		background-color: rgba(29, 26, 26, 0.6);
		::v-deep {
			.el-skeleton__image svg {
				fill: #333;
			}
		}
	}
	.app-skeleton-img {
		margin: 0px auto;
		background-color: rgba(29, 26, 26, 0.6);
		width: 96%;
		height: 500px;
	}
	.skeleton-img-list {
		display: flex;
		justify-content: space-around;
	}
	.skelet {
		padding: 30px 0px;
		padding-bottom: 60px;
	}
</style>
